import {createContext, useEffect, useState} from "react";
import axiosInstance from "./AxiosInstance";

const MyContext = createContext("");

export function ContextProvider({children}) {
    const [user, setUser] = useState({});
    const [isClient, setIsClient] = useState(false);
    const authenticated = localStorage.getItem('access_token') !== null;
    const [authReady, setAuthReady] = useState(!authenticated);

    useEffect(() => {
        if (!authenticated) {
            setAuthReady(true);
            setIsClient(false);
            return;
        }
        setAuthReady(false);
        axiosInstance.get('current_user/').then((response) => {
                if(response.status !== 200) {
                    localStorage.setItem("system_settings", "{\"image\":null,\"main_color\":\"#FF1235\",\"fade_start\":\"#7376CA\",\"secondary_color\":\"#6E70C8\"}");
                    setIsClient(false);
                    return;
                }
                setUser(response.data)
                localStorage.setItem('company_factoring_approved', response.data.company_factoring_approved.toString());
                localStorage.setItem('seller_uuid', response.data.seller_uuid.toString());
                localStorage.setItem('system_settings', JSON.stringify(response.data.company));
                setIsClient(!!response.data.is_staff);
            }).catch(() => {
                setIsClient(false);
            }).finally(() => {
                setAuthReady(true);
            });
    }, [authenticated])

    return (
        <MyContext.Provider value={{user, isClient, authReady}}>
            {children}
        </MyContext.Provider>
    );
}

export default MyContext;